function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a0adbc;}.cls-2{fill:#1e53bc;}.cls-3{fill:#cc0606;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M115.62,19.83v80.9a7.49,7.49,0,0,1-7.47,7.47H63.5L71,100.73h37.18V19.83H53.38V58.25l-4.93-4.93a12.22,12.22,0,0,0-2.54-1.94V19.83a7.5,7.5,0,0,1,7.47-7.47h54.77A7.49,7.49,0,0,1,115.62,19.83Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M71.14,83.05,44.93,56.84a7.44,7.44,0,0,0-10.48,0L8.25,83.05a7.44,7.44,0,0,0,0,10.48l26.2,26.2a7.44,7.44,0,0,0,10.48,0l26.21-26.2A7.44,7.44,0,0,0,71.14,83.05ZM23.51,93.27a5,5,0,1,1,5-5A5,5,0,0,1,23.51,93.27Zm16.18,16.18a5,5,0,1,1,5-5A5,5,0,0,1,39.69,109.45Zm0-16.18a5,5,0,1,1,5-5A5,5,0,0,1,39.69,93.27Zm0-16.18a5,5,0,1,1,5-5A5,5,0,0,1,39.69,77.09ZM55.87,93.27a5,5,0,1,1,5-5A5,5,0,0,1,55.87,93.27Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M89.37,69.64A84.79,84.79,0,0,1,99.44,59,84.51,84.51,0,0,1,89.37,48.43,94.13,94.13,0,0,1,80.77,36a95.34,95.34,0,0,1-8.6,12.42A85.39,85.39,0,0,1,62.1,59a85.67,85.67,0,0,1,10.07,10.6,95.34,95.34,0,0,1,8.6,12.42A94.13,94.13,0,0,1,89.37,69.64Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M63.77,32a22.7,22.7,0,0,1,2.68-2.87,22.11,22.11,0,0,1-2.68-2.86,25.58,25.58,0,0,1-2.3-3.36,24.83,24.83,0,0,1-2.29,3.36,22.53,22.53,0,0,1-2.69,2.86A23.15,23.15,0,0,1,59.18,32a24.83,24.83,0,0,1,2.29,3.36A25.58,25.58,0,0,1,63.77,32Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M102.35,94.27A22.27,22.27,0,0,1,105,91.4a23.15,23.15,0,0,1-2.69-2.87,25.15,25.15,0,0,1-2.29-3.35,26.4,26.4,0,0,1-2.29,3.35,23.15,23.15,0,0,1-2.69,2.87,22.27,22.27,0,0,1,2.69,2.87,26.4,26.4,0,0,1,2.29,3.35A25.15,25.15,0,0,1,102.35,94.27Z"
});

const SvgCasinonw = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCasinonw, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/casinonw.7ca6d9b0.svg";
export { ForwardRef as ReactComponent };